// @tennis-matches/services/auth/registration-legal
// Versionierte Einwilligungen bei Selbstregistrierung (DSGVO-Nachweis in user_metadata).

/** Version der Datenschutz-/AGB-Dokumente zum Zeitpunkt der Registrierung. Bei Textänderung erhöhen. */
export const REGISTRATION_LEGAL_DOCUMENT_VERSION = "2026-05-18";

/**
 * @param {{ privacyAccepted?: boolean, termsAccepted?: boolean, marketingAccepted?: boolean }} opts
 * @returns {{ privacy: object|null, terms: object|null, marketing: object|null }}
 */
export function buildRegistrationLegalConsents({
  privacyAccepted = false,
  termsAccepted = false,
  marketingAccepted = false,
} = {}) {
  const now = new Date().toISOString();
  const version = REGISTRATION_LEGAL_DOCUMENT_VERSION;
  return {
    privacy: privacyAccepted ? { version, accepted_at: now } : null,
    terms: termsAccepted ? { version, accepted_at: now } : null,
    marketing: marketingAccepted ? { version, accepted_at: now } : null,
  };
}

/**
 * @param {import("@supabase/supabase-js").User | null | undefined} user
 * @returns {boolean}
 */
export function isAuthUserEmailConfirmed(user) {
  if (!user || typeof user !== "object") return false;
  if (user.email_confirmed_at) return true;
  if (user.confirmed_at) return true;
  const identities = Array.isArray(user.identities) ? user.identities : [];
  return identities.some((id) => {
    const data = id?.identity_data && typeof id.identity_data === "object" ? id.identity_data : {};
    return data.email_verified === true;
  });
}
